/* ==========================================================================
   Nicosé Chatbot — asistente de compra guiado por botones + texto libre
   --------------------------------------------------------------------------
   PARA EDITAR CONTENIDO: modifica el objeto FLOWS más abajo.
   - texto del flujo .......... flow.text
   - botones del flujo ........ flow.options[]
       { label, goto }                  -> navega a otro flujo
       { label, menu: true }            -> vuelve al menú principal
       { label, url }                   -> abre un enlace del sitio
       { label, wa: "mensaje..." }      -> abre WhatsApp con texto prellenado
   PARA EDITAR LA DETECCIÓN DE TEXTO LIBRE: modifica INTENTS (orden = prioridad).
   El número de WhatsApp y las URLs llegan desde el snippet (data-* attrs),
   así que NO se tocan acá. Cambiar el número en snippets/nicose-chatbot.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('nicose-chatbot');
  if (!root) return;

  var WA_NUMBER = root.dataset.waNumber || '';
  var URL_STOCK = root.dataset.urlStock || '/collections/all';
  var URL_TALLA = root.dataset.urlTalla || '/pages/recomendador-de-talla';
  var URL_ESTADO = root.dataset.urlEstado || '/pages/estado-de-fabricacion';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TYPING_MS = REDUCED_MOTION ? 0 : 600;

  // --- Definición de flujos (100% editable) --------------------------------
  var FLOWS = {
    menu: {
      text: 'Hola 💖 Soy el asistente de Nicosé. Te ayudo a revisar stock, elegir talla, ver precios o diseñar tu top.\n\nElige una opción o escríbeme abajo — puedo buscar diseños por personaje o color, por ejemplo "Stitch" o "top azul" 👇',
      options: [
        { label: '🛍️ Ver tops disponibles ahora', goto: 'stock', primary: true },
        { label: '📏 Guía de tallas', goto: 'talla' },
        { label: '💲 Ver precios', goto: 'precios' },
        { label: '🎨 Diseñar top personalizado', goto: 'personalizado' },
        { label: 'Más opciones', goto: 'mas_opciones', secondary: true },
        { label: 'Hablar por WhatsApp', wa: 'Hola Nicosé, necesito ayuda con una consulta.', track: 'whatsapp', waFinal: true }
      ]
    },

    mas_opciones: {
      track: 'mas_opciones',
      text: 'También puedo ayudarte con envíos, plazos o seguimiento de pedido.',
      options: [
        { label: '🚚 Envíos y plazos', goto: 'envios' },
        { label: '📦 Seguimiento de pedido', goto: 'seguimiento' },
        { label: '🛍️ Ver tops disponibles ahora', goto: 'stock' },
        { label: 'Hablar por WhatsApp', wa: 'Hola Nicosé, necesito ayuda con una consulta.', track: 'whatsapp', waFinal: true },
        { label: '← Volver al menú', menu: true }
      ]
    },

    precios: {
      track: 'precios',
      text: 'Nuestros tops clínicos personalizados tienen estos valores:\n\n• Hasta XL: $30.000\n• 2XL a 3XL: $32.000\n• 4XL a 5XL: $36.000\n\nEl tiempo de confección es de 15 días hábiles desde que ingresa al taller.',
      options: [
        { label: '🎨 Diseñar top personalizado', goto: 'personalizado' },
        { label: '📏 Guía de tallas', goto: 'talla' },
        { label: 'Hablar por WhatsApp', wa: 'Hola Nicosé, necesito ayuda con una consulta.', track: 'whatsapp' },
        { label: '← Volver al menú', menu: true }
      ]
    },

    talla: {
      track: 'talla',
      text: 'Para ayudarte con la talla, revisa tu contorno de busto y compáralo con nuestra guía de medidas. Si estás entre dos tallas, recomendamos elegir la talla mayor para mayor comodidad, especialmente si prefieres que el top no quede ajustado.\n\nTambién puedes usar el recomendador de tallas en nicose.cl 👇',
      options: [
        { label: '📏 Abrir recomendador de tallas', url: URL_TALLA },
        { label: '💲 Ver precios', goto: 'precios' },
        { label: '🎨 Diseñar top personalizado', goto: 'personalizado' },
        { label: 'Hablar por WhatsApp sobre mi talla', wa: 'Hola Nicosé, necesito ayuda para elegir mi talla.', track: 'whatsapp' },
        { label: '← Volver al menú', menu: true }
      ]
    },

    personalizado: {
      track: 'personalizado',
      text: 'Perfecto 💖 Para encargar un personalizado necesitamos:\n\n1. Color base del top\n2. Diseño, personaje o temática\n3. Imagen de referencia si tienes\n4. Talla\n\nLos personalizados tienen un tiempo de confección de 15 días hábiles desde que ingresan al taller.',
      options: [
        { label: '💲 Ver precios', goto: 'precios' },
        { label: '📏 Guía de tallas', goto: 'talla' },
        { label: 'Enviar datos por WhatsApp', wa: 'Hola Nicosé, quiero un top personalizado. Mi talla es: __. Color base: __. Diseño/temática: __.', track: 'whatsapp' },
        { label: '← Volver al menú', menu: true }
      ]
    },

    envios: {
      track: 'envios',
      text: 'Los tops personalizados tienen un tiempo de confección de 15 días hábiles desde que ingresan al taller. El envío se calcula aparte según comuna o región.\n\nSi necesitas tu pedido para una fecha específica, escríbenos por WhatsApp antes de comprar para revisar si alcanzamos a gestionarlo.',
      options: [
        { label: 'Consultar envío por WhatsApp', wa: 'Hola Nicosé, quiero consultar por envío. Mi comuna/región es: __.', track: 'whatsapp' },
        { label: '💲 Ver precios', goto: 'precios' },
        { label: '🎨 Diseñar top personalizado', goto: 'personalizado' },
        { label: '← Volver al menú', menu: true }
      ]
    },

    stock: {
      track: 'stock',
      text: 'Puedes revisar los tops disponibles para despacho rápido. Si buscas una talla o diseño específico, escríbenos por WhatsApp y confirmamos disponibilidad.',
      options: [
        { label: '🛍️ Ver tops disponibles ahora', url: URL_STOCK },
        { label: 'Hablar por WhatsApp', wa: 'Hola Nicosé, quiero consultar disponibilidad de stock.', track: 'whatsapp' },
        { label: '🎨 Diseñar top personalizado', goto: 'personalizado' },
        { label: '← Volver al menú', menu: true }
      ]
    },

    seguimiento: {
      track: 'seguimiento',
      text: 'Si ya hiciste un pedido, podemos ayudarte a revisar el estado. Ten a mano tu nombre o número de pedido.',
      options: [
        { label: 'Consultar por WhatsApp', wa: 'Hola Nicosé, quiero consultar por el estado de mi pedido. Mi nombre es: __. Número de pedido si lo tengo: __.', track: 'whatsapp' },
        { label: '📦 Ver estado de fabricación', url: URL_ESTADO },
        { label: '← Volver al menú', menu: true }
      ]
    }
  };

  // --- Detección de intención para texto libre (orden = prioridad) ---------
  // Las palabras se comparan SIN tildes y en minúsculas (ñ → n).
  var INTENTS = [
    { flow: 'precios', words: ['precio', 'valor', 'cuanto', 'cuesta', 'vale', 'cobran', 'pago', 'abono', 'descuento'] },
    { flow: 'envios', words: ['envio', 'despacho', 'demora', 'llega', 'region', 'comuna', 'starken', 'bluexpress', 'plazo'] },
    { flow: 'seguimiento', words: ['seguimiento', 'estado de mi', 'mi pedido', 'mi orden', 'mi compra', 'compre', 'rastrear', 'tracking'] },
    { flow: 'stock', words: ['stock', 'disponible', 'inmediata', 'inmediato', 'catalogo', 'comprar ya'] },
    { flow: 'personalizado', words: ['personalizado', 'personalizar', 'diseno', 'personaje', 'estampado', 'logo', 'bordado', 'anime', 'kpop'] },
    { flow: 'talla', words: ['talla', 'medida', 'busto', 'contorno', 'queda', 'xxs', 'xl', 'grande', 'ajustado'] }
  ];

  // --- Reconocimiento de productos y colores (Shopify Predictive Search) ---
  // No hay listas de productos hardcodeadas: se consulta el stock real de la
  // tienda v\u00eda /search/suggest.json (solo productos disponibles).
  var STOPWORDS = ['hola', 'buenas', 'buenos', 'dias', 'tardes', 'noches', 'quiero', 'quisiera', 'busco', 'buscando', 'tienen', 'tiene', 'tienes', 'hay', 'necesito', 'gustaria', 'venden', 'ver', 'mostrar', 'muestrame', 'tengo', 'con', 'para', 'por', 'del', 'los', 'las', 'una', 'uno', 'unos', 'unas', 'que', 'cual', 'cuales', 'algun', 'alguna', 'alguno', 'este', 'esta', 'estos', 'estas', 'top', 'tops', 'uniforme', 'uniformes', 'clinico', 'clinicos', 'clinica', 'pero', 'como', 'donde', 'cuando', 'quien', 'favor', 'porfa', 'gracias', 'algo', 'mas', 'muy', 'solo', 'color', 'colores', 'modelo', 'modelos', 'estilo', 'estilos', 'tipo', 'tipos'];
  var COLORS = ['azul', 'marino', 'negro', 'blanco', 'rosado', 'rosa', 'burdeo', 'vino', 'morado', 'lila', 'lavanda', 'verde', 'militar', 'calipso', 'celeste', 'gris', 'beige', 'fucsia', 'turquesa', 'mostaza', 'amarillo', 'rojo', 'naranjo', 'naranja', 'crema'];

  function normalize(text) {
    return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  // Palabras de intenci\u00f3n (de una sola palabra) \u2014 se excluyen de la b\u00fasqueda de productos
  var INTENT_WORD_SET = {};
  INTENTS.forEach(function (it) {
    it.words.forEach(function (w) {
      if (w.indexOf(' ') === -1) INTENT_WORD_SET[w] = true;
    });
  });

  // Extrae las palabras "de producto" del texto: sin saludos, sin palabras de
  // intenci\u00f3n, singularizadas (la b\u00fasqueda de Shopify matchea por prefijo).
  function extractTokens(text) {
    var clean = normalize(text).replace(/[^a-z0-9\s]/g, ' ');
    var out = [];
    clean.split(/\s+/).forEach(function (w) {
      if (w.length < 3) return;
      if (STOPWORDS.indexOf(w) !== -1) return;
      if (INTENT_WORD_SET[w]) return;
      if (w.length > 3 && w.charAt(w.length - 1) === 's') w = w.slice(0, -1);
      if (out.indexOf(w) === -1) out.push(w);
    });
    return out.slice(0, 4);
  }

  function searchProducts(query, cb) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=3' +
      '&resources[options][unavailable_products]=hide' +
      '&resources[options][fields]=title,product_type';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        cb((d.resources && d.resources.results && d.resources.results.products) || []);
      })
      .catch(function () { cb(null); });
  }

  // Prueba consultas en orden (completa \u2192 sin color \u2192 solo color) y entrega
  // la primera con resultados.
  function attemptSearch(queries, onFound, onNone) {
    if (!queries.length) { onNone(); return; }
    var q = queries.shift();
    searchProducts(q, function (products) {
      if (products && products.length) onFound(products, q);
      else attemptSearch(queries, onFound, onNone);
    });
  }

  function buildQueries(tokens) {
    var queries = [tokens.join(' ')];
    var nonColor = tokens.filter(function (t) { return COLORS.indexOf(t) === -1; });
    var color = tokens.filter(function (t) { return COLORS.indexOf(t) !== -1; }).join(' ');
    if (nonColor.length && nonColor.length < tokens.length) queries.push(nonColor.join(' '));
    if (color && tokens.length > 1) queries.push(color);
    return queries.filter(function (q, i) { return q && queries.indexOf(q) === i; });
  }

  function clp(value) {
    return '$' + Math.round(Number(value)).toLocaleString('es-CL');
  }

  function matchIntent(text) {
    var clean = normalize(text);
    for (var i = 0; i < INTENTS.length; i++) {
      var words = INTENTS[i].words;
      for (var j = 0; j < words.length; j++) {
        if (clean.indexOf(words[j]) !== -1) return INTENTS[i].flow;
      }
    }
    return null;
  }

  // --- Tracking hook (GA4 vía gtag, cargado en snippets/nicose-chatbot.liquid)
  function track(name) {
    if (!name) return;
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'nicose_chatbot', { step: name });
    }
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'nicose_chatbot', step: name });
    }
  }

  // --- Render --------------------------------------------------------------
  var panel = root.querySelector('.nicose-chatbot__panel');
  var bodyEl = root.querySelector('.nicose-chatbot__body');
  var launcher = root.querySelector('.nicose-chatbot__launcher');
  var closeBtn = root.querySelector('.nicose-chatbot__close');
  var inputForm = root.querySelector('.nicose-chatbot__inputbar');
  var inputEl = root.querySelector('.nicose-chatbot__input');
  var rendered = false;
  var busy = false; // evita doble click mientras el bot "escribe"

  function waLink(message) {
    return 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(message);
  }

  function scrollDown() {
    requestAnimationFrame(function () {
      bodyEl.scrollTop = bodyEl.scrollHeight;
    });
  }

  // Elimina los grupos de botones anteriores: queda solo el historial de
  // burbujas y un único set de opciones activo al final.
  function clearOptions() {
    var groups = bodyEl.querySelectorAll('.nicose-chatbot__options');
    for (var i = 0; i < groups.length; i++) groups[i].remove();
  }

  // Burbuja del usuario (eco de su elección o pregunta)
  function echoUser(text) {
    var msg = document.createElement('div');
    msg.className = 'nicose-chatbot__msg nicose-chatbot__msg--user';
    msg.textContent = text;
    bodyEl.appendChild(msg);
    scrollDown();
  }

  // Quita el emoji/símbolo inicial del label para el eco ("📏 Guía..." → "Guía...")
  function cleanLabel(label) {
    return label.replace(/^[^0-9A-Za-zÁÉÍÓÚÜÑáéíóúüñ¿¡]+/, '').trim() || label;
  }

  function showTyping() {
    var typing = document.createElement('div');
    typing.className = 'nicose-chatbot__msg nicose-chatbot__typing';
    typing.setAttribute('aria-label', 'El asistente está escribiendo');
    typing.innerHTML = '<span></span><span></span><span></span>';
    bodyEl.appendChild(typing);
    scrollDown();
    return typing;
  }

  // Indicador "escribiendo…" y luego ejecuta callback
  function botThinks(callback) {
    if (TYPING_MS === 0) { callback(); return; }
    busy = true;
    var typing = showTyping();
    setTimeout(function () {
      typing.remove();
      busy = false;
      callback();
    }, TYPING_MS);
  }

  function renderOptions(options) {
    var opts = document.createElement('div');
    opts.className = 'nicose-chatbot__options';

    options.forEach(function (o) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = o.label;

      var classes = ['nicose-chatbot__opt'];
      if (o.wa) classes.push('nicose-chatbot__opt--wa');
      if (o.waFinal) classes.push('nicose-chatbot__opt--wa-final');
      if (o.primary) classes.push('nicose-chatbot__opt--primary');
      if (o.secondary) classes.push('nicose-chatbot__opt--secondary');
      if (o.menu || /Volver al menú/i.test(o.label)) classes.push('nicose-chatbot__opt--back');
      btn.className = classes.join(' ');

      btn.addEventListener('click', function () {
        if (busy) return;
        if (o.track) track(o.track);
        if (o.wa) {
          // No borra las opciones: la clienta sigue en el chat al volver de WhatsApp
          window.open(waLink(o.wa), '_blank', 'noopener');
        } else if (o.url) {
          window.location.href = o.url;
        } else if (o.menu || o.goto) {
          echoUser(cleanLabel(o.label));
          clearOptions();
          botThinks(function () { renderFlow(o.menu ? 'menu' : o.goto); });
        }
      });
      opts.appendChild(btn);
    });

    bodyEl.appendChild(opts);
    scrollDown();
  }

  function renderFlow(id) {
    var flow = FLOWS[id];
    if (!flow) return;
    track(flow.track);

    var msg = document.createElement('div');
    msg.className = 'nicose-chatbot__msg';
    msg.textContent = flow.text;
    bodyEl.appendChild(msg);

    renderOptions(flow.options);
  }

  // Tarjetas de producto recomendado (resultado de la búsqueda en vivo)
  function renderProducts(products, query) {
    track('product_reco');

    var msg = document.createElement('div');
    msg.className = 'nicose-chatbot__msg';
    msg.textContent = 'Mira lo que encontré disponible para ti 💖 Toca uno para verlo:';
    bodyEl.appendChild(msg);

    var list = document.createElement('div');
    list.className = 'nicose-chatbot__products';

    products.forEach(function (p) {
      var card = document.createElement('a');
      card.className = 'nicose-chatbot__product';
      card.href = p.url;

      if (p.featured_image && p.featured_image.url) {
        var img = document.createElement('img');
        img.src = p.featured_image.url + (p.featured_image.url.indexOf('?') === -1 ? '?' : '&') + 'width=120';
        img.alt = '';
        img.loading = 'lazy';
        card.appendChild(img);
      }

      var info = document.createElement('span');
      info.className = 'nicose-chatbot__product-info';

      var title = document.createElement('span');
      title.className = 'nicose-chatbot__product-title';
      title.textContent = p.title;
      info.appendChild(title);

      var price = document.createElement('span');
      price.className = 'nicose-chatbot__product-price';
      price.textContent = Number(p.price_min) < Number(p.price_max)
        ? 'desde ' + clp(p.price_min)
        : clp(p.price_min);
      info.appendChild(price);

      card.appendChild(info);
      list.appendChild(card);
    });

    bodyEl.appendChild(list);

    renderOptions([
      { label: '🔍 Ver más resultados', url: '/search?q=' + encodeURIComponent(query) + '&type=product' },
      { label: 'Preguntar por WhatsApp', wa: 'Hola Nicosé 💖 Estoy buscando: ' + query + '. ¿Me ayudas?', track: 'whatsapp' },
      { label: '← Volver al menú', menu: true }
    ]);
  }

  // Fallback cuando el texto libre no calza con ningún flujo
  function renderFallback(question) {
    track('free_text_fallback');

    var msg = document.createElement('div');
    msg.className = 'nicose-chatbot__msg';
    msg.textContent = 'No estoy segura de haber entendido 🙈 pero el equipo de Nicosé te responde altiro por WhatsApp — tu pregunta ya va escrita.';
    bodyEl.appendChild(msg);

    renderOptions([
      { label: 'Enviar mi pregunta por WhatsApp', wa: 'Hola Nicosé 💖 Tengo una consulta: ' + question, track: 'whatsapp', waFinal: true },
      { label: '← Volver al menú', menu: true }
    ]);
  }

  // --- Texto libre -----------------------------------------------------------
  if (inputForm && inputEl) {
    inputForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var text = inputEl.value.trim();
      if (!text || busy) return;
      inputEl.value = '';

      if (!rendered) rendered = true;
      track('free_text');
      echoUser(text);
      clearOptions();

      var flowId = matchIntent(text);
      var tokens = extractTokens(text);

      // Sin palabras de producto: responder con el flujo de intención o fallback
      if (!tokens.length) {
        botThinks(function () {
          flowId ? renderFlow(flowId) : renderFallback(text);
        });
        return;
      }

      // Hay palabras de producto/color: buscar en el stock real de la tienda.
      // El typing queda visible mientras dura la consulta (mínimo TYPING_MS).
      busy = true;
      track('product_search');
      var typing = showTyping();
      var started = Date.now();
      function finish(fn) {
        var wait = Math.max(0, TYPING_MS - (Date.now() - started));
        setTimeout(function () {
          typing.remove();
          busy = false;
          fn();
        }, wait);
      }

      attemptSearch(
        buildQueries(tokens),
        function (products, matchedQuery) {
          finish(function () { renderProducts(products, matchedQuery); });
        },
        function () {
          track('product_reco_none');
          finish(function () {
            flowId ? renderFlow(flowId) : renderFallback(text);
          });
        }
      );
    });
  }

  // --- Abrir / cerrar ------------------------------------------------------
  function open() {
    if (!rendered) { renderFlow('menu'); rendered = true; }
    root.classList.add('is-open');
    launcher.setAttribute('aria-expanded', 'true');
    track('open');
    setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 220);
  }

  function close() {
    root.classList.remove('is-open');
    launcher.setAttribute('aria-expanded', 'false');
    launcher.focus();
  }

  launcher.addEventListener('click', function () {
    root.classList.contains('is-open') ? close() : open();
  });
  closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });
})();
